// prettier-ignore
// A comma is added after the generic type <T,> to avoid an esbuild issue
// where it confuses TypeScript generics with JSX.
// Issue reference: https://github.com/evanw/esbuild/issues/2363
export const includesAny = <T,>(array: T[] = [], elementsToCheck: T[] = []) => {
  const arraySet = new Set(array)
  return elementsToCheck.some(element => arraySet.has(element))
}
